import { render, staticRenderFns } from "./AccommodationVariants.vue?vue&type=template&id=89166bd4"
import script from "./AccommodationVariants.vue?vue&type=script&lang=js"
export * from "./AccommodationVariants.vue?vue&type=script&lang=js"
import style0 from "./AccommodationVariants.vue?vue&type=style&index=0&id=89166bd4&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports